import { ThemeProvider, StyledEngineProvider, CssBaseline } from "@mui/material";
import { themeCreator } from "../themes/pageThemes";
import { useAppSelector } from "../hooks/reduxHooks";

interface AppThemeProps {
	children: JSX.Element;
}

const AppThemeProvider = (props: AppThemeProps) => {
	// State to hold the selected theme name
	const { children } = props;

	const themeName = useAppSelector((state) => state.theme.themeName);
	const themeType = useAppSelector((state) => state.theme.themeType);
	const themeSize = useAppSelector((state) => state.theme.themeSize);

	const theme = themeCreator(themeName, themeType, themeSize);
	//userpref === "dark" ? dispatch(setThemeTypeDark()) : dispatch(setThemeTypeLight());
	//	dispatch(updateThemeSize(userprefSize));

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{children}
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

export default AppThemeProvider;
